<script setup lang="ts">
import {
  MMLink,
  MMText,
  MMContainer,
  MMAccordion,
  MMIcon,
  MMPopupFullScreen,
} from '@mm-frontend/mm-web-ui-kit';
import { useAuthSDK } from '~/features/auth-sdk';
import { getApplicationLink } from '~/shared/helpers/applicationLink';
import { USER_MODAL_CONFIG } from '../business/userModalConfig';
import { ERouteName } from '~/app/router/routeName.enum';
import AuthSnippet from './snippets/AuthSnippet.vue';
import CitySnippet from './snippets/CitySnippet.vue';

const { isAuthorized } = useAuthSDK();
const links = USER_MODAL_CONFIG.links;
</script>

<template>
  <MMPopupFullScreen>
    <div class="user-modal">
      <MMContainer class="user-modal__header">
        <MMText font="Title S/Semibold Long" class="user-modal__header__title">Кабинет</MMText>
        <AuthSnippet />
      </MMContainer>

      <MMContainer class="user-modal__block">
        <MMLink v-if="isAuthorized" :to="{ name: ERouteName.USER_ORDERS }">
          <MMIcon name="cart" :height="24" :width="24" />
          <MMText font="Body M/Regular">Мои заказы</MMText>
        </MMLink>

        <CitySnippet />

        <MMLink :to="{ name: ERouteName.ABOUT_DELIVERY_POINTS }">
          <MMIcon name="map-outlined" :height="24" :width="24" />
          <MMText font="Body M/Regular">Пункты выдачи</MMText>
        </MMLink>
      </MMContainer>

      <MMContainer class="user-modal__block">
        <MMLink :to="{ name: ERouteName.FAQ }">
          <MMIcon name="help-outlined" :height="24" :width="24" />
          <MMText font="Body M/Regular">Вопрос-ответ</MMText>
        </MMLink>
        <MMLink to="#contacts">
          <MMIcon name="main-outlined" :height="24" :width="24" />
          <MMText font="Body M/Regular">Связаться с нами</MMText>
        </MMLink>
        <MMLink :to="getApplicationLink()" outer>
          <MMIcon name="application-outlined" :height="24" :width="24" />
          <MMText font="Body M/Regular">Приложение Магнит Маркет</MMText>
        </MMLink>
      </MMContainer>

      <MMContainer class="user-modal__block user-modal__info">
        <MMAccordion single-open>
          <template #header-0>
            <MMText font="Body M/Regular">О нас</MMText>
          </template>
          <template #content-0>
            <MMLink
              v-for="link in links.about.items"
              :key="link.title"
              :to="link.to"
              :target="link.target"
              :label="link.title"
            />
          </template>

          <template #header-1>
            <MMText font="Body M/Regular">Партнёрам</MMText>
          </template>
          <template #content-1>
            <MMLink
              v-for="link in links.partners.items"
              :key="link.title"
              :to="link.to"
              :target="link.target"
              :label="link.title"
            />
          </template>
        </MMAccordion>
      </MMContainer>
    </div>
  </MMPopupFullScreen>
</template>

<style lang="stylus" scoped>
.user-modal
  background var(--background-secondary)
  height 100%
  display flex
  flex-direction column
  gap 12px
  box-sizing border-box

  & *
    box-sizing border-box

  &__header
    margin 0 auto
    border-radius 0 0 16px 16px
    padding 4px 8px
    display flex
    flex-direction column
    gap 4px
    & .mm-link
      padding 10px 16px 10px 10px
      gap 10px
      display flex
      align-items center
    &__title
      padding 12px 0
      text-align center

  & .mm-link
    display flex
    width 100%

  & .mm-container
    background var(--background-primary)

  &__block
    margin 0 auto
    border-radius 16px
    padding 4px 8px
    display flex
    flex-direction column
    & .mm-link
      padding 10px 16px 10px 10px
      gap 10px
      display flex
      align-items center

  &__profile
    &-info
      display flex
      flex-direction column

  &__info
    :deep(.mm-accordion-item__content)
      display flex
      flex-direction column
      gap 8px
</style>
